import { ApiChainSymbols, ApiCurrencySymbols } from './enums';

export interface CurrencyFeatureFlags {
  widgetSolCurrency: boolean | undefined;
  widgetBnbCurrency: boolean | undefined;
  widgetBaseNetwork: boolean | undefined;
  widgetUsdcSolanaCurrency: boolean | undefined;
  widgetWalletConnectPay: boolean | undefined;
}

export const isFlaggedCurrencyVisible = (
  symbol: string,
  flags: Partial<CurrencyFeatureFlags>
) => {
  if (symbol === ApiCurrencySymbols.SOL) return Boolean(flags.widgetSolCurrency);
  if (symbol === ApiCurrencySymbols.BNB) return Boolean(flags.widgetBnbCurrency);
  return true;
};

export const isFlaggedChainVisible = (
  chainSymbol: string,
  flags: Partial<CurrencyFeatureFlags>
) => {
  if (chainSymbol === ApiChainSymbols.BASE)
    return Boolean(flags.widgetBaseNetwork);
  if (chainSymbol === ApiChainSymbols.WalletConnectPay)
    return Boolean(flags.widgetWalletConnectPay);
  return true;
};

export const isFlaggedCurrencyChainVisible = (
  currencySymbol: string,
  chainSymbol: string,
  flags: Partial<CurrencyFeatureFlags>
) => {
  if (
    currencySymbol === ApiCurrencySymbols.USDC &&
    chainSymbol === ApiChainSymbols.SOLANA
  )
    return Boolean(flags.widgetUsdcSolanaCurrency);
  return true;
};

export const currencyOrder = [
  ApiCurrencySymbols.USDC,
  ApiCurrencySymbols.BTC,
  ApiCurrencySymbols.ETH,
  ApiCurrencySymbols.SOL,
  ApiCurrencySymbols.BNB,
  ApiCurrencySymbols.POL,
  ApiCurrencySymbols.SUI,
  ApiCurrencySymbols.EGLD,
  ApiCurrencySymbols.DASH,
  ApiCurrencySymbols.USDT,
];

export const blockchainOrder = [
  ApiChainSymbols.ERD,
  ApiChainSymbols.POLYGON,
  ApiChainSymbols.TRX,
  ApiChainSymbols.ETH,
  ApiChainSymbols.BASE,
  ApiChainSymbols.BSC,
  ApiChainSymbols.SOLANA,
  ApiChainSymbols.SOL,
  ApiChainSymbols.WalletConnectPay,
  ApiChainSymbols.BTC,
];
